import { useLingui } from '../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import { passwordManagerDisableAutofillProps } from '../../../utils/passwordManagerDisableAutofillProps.mjs';
import Input from './Input.mjs';

const EmailInput = ({ email, setEmail, hasPasskeys = false, ...additionalProps })=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    return /*#__PURE__*/ React__default.createElement(Input, {
        id: "email-input",
        label: $__i18n._({
            id: "formField.email.label"
        }),
        placeholder: $__i18n._({
            id: "formField.email.placeholder"
        }),
        type: "email",
        autoComplete: hasPasskeys ? 'username webauthn' : 'email',
        value: email,
        onChange: (e)=>setEmail(e.target.value),
        required: true,
        ...hasPasskeys ? passwordManagerDisableAutofillProps : {},
        ...additionalProps
    });
};

export { EmailInput as default };
//# sourceMappingURL=EmailInput.mjs.map
